module.exports = __webpack_public_path__ + "static/media/bg.0c3a3f04.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/bg.jpg
 ** module id = 697
 ** module chunks = 0
 **/